module.exports = __webpack_public_path__ + "assets/img/b_img.5f1535c1.png";